import { ProfileApprovalState, User } from './auth';

export interface Dictionary {
  [key: string]: any;
}

export interface PagenatedResponse<T> {
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
  contents: T[];
  summary?: { successCount?: number; failureCount?: number };
}
export interface PhoneValidatorResponse {
  // validationCode?: number;
  tts?: number;
}

export interface UserEventRecord {
  _id: string;
  userId: string;
  eventKey: string;
  data: any;
}

export interface MainFeedMarketingModalOption {
  isActive: boolean;
  isAutoSwipeMarketingPopUp: boolean;
  marketingPopUpSwipeStartTerms: number;
  marketingPopUpSwipeTerms: number;
  isRandomDisplay: boolean;
}

export enum DeepLinkActions {
  GO_TO_CHAT = 'go_to_chat',
  GO_TO_CHAT_LIST = 'go_to_chat_list',
  GO_TO_CLASS_COLLECTION = 'go_to_class_collection',
  GO_TO_CLASS_DETAIL = 'go_to_class_detail',
  GO_TO_COLLECTION = 'go_to_collection',
  GO_TO_COLLECTION_V2 = 'go_to_collection_v2',
  GO_TO_COMMERCE_COLLECTION = 'go_to_commerce_collection',
  GO_TO_COMMERCE_DETAIL = 'go_to_commerce_detail',
  GO_TO_COMMUNITY = 'go_to_community',
  GO_TO_COUPON = 'go_to_coupon',
  GO_TO_DEALS = 'go_to_deals',
  GO_TO_DEALS_DETAIL = 'go_to_deals_detail',
  GO_TO_EVENT = 'go_to_event',
  GO_TO_FAVORITES = 'go_to_favorites',
  GO_TO_FEEDBACK = 'go_to_feedback',
  GO_TO_LOUNGE = 'go_to_lounge',
  GO_TO_LOUNGE_PROFILE = 'go_to_lounge_profile',
  GO_TO_MAIN = 'go_to_main',
  GO_TO_MY_PAGE = 'go_to_my_page',
  GO_TO_NOTICE = 'go_to_notice',
  GO_TO_NEWS = 'go_to_news',
  GO_TO_PARTNER = 'go_to_partner',
  GO_TO_PARTNER_CHAT_LIST = 'go_to_partner_chat_list',
  GO_TO_PICK = 'go_to_pick',
  GO_TO_POINT = 'go_to_point',
  GO_TO_PRODUCT = 'go_to_product',
  GO_TO_PRODUCT_REVIEW = 'go_to_product_review',
  GO_TO_PRODUCT_REVIEW_IMAGES = 'go_to_product_review_images',
  GO_TO_PROGRAM_REPORT = 'go_to_program_report',
  GO_TO_PURCHASE = 'go_to_purchase',
  GO_TO_PURCHASE_DETAIL = 'go_to_purchase_detail',
  GO_TO_REWARD = 'go_to_reward',
  GO_TO_THEME_COLLECTION = 'go_to_theme_collection',
  GO_TO_SELF_ASSESSMENT = 'go_to_self_assessment',
  GO_TO_MBTI_TEST = 'go_to_mbti_test',
  OPEN_APP_LOGIN_MODAL = 'open_app_login_modal',
  OPEN_LINK = 'open_link',
  OPEN_OS_BROWSER = 'open_os_browser',
  SEARCH_KEYWORD = 'search_keyword',
  SEARCH_KEYWORD_V2 = 'search_keyword_v2',
}

export interface DeeplinkActionPayload {
  classId?: string;
  tutorId?: string;
  partnerId?: string;
  parentId?: string;
  chatRoomId?: string;
  collectionId?: string;
  brandId?: string;
  productId?: string;
  lastChanceItemId?: string;
  userContentId?: string;
  title?: string;
  keyword?: string;
  url?: string;
  noticeId?: string;
  tab?: string;
  write?: boolean;
}
export interface DeeplinkAction {
  action?: DeepLinkActions;
  payload?: DeeplinkActionPayload;
}

export interface PagenatedQuery {
  page?: number;
  size?: number;
}

export interface DatePeriodQuery {
  startDate?: string | null;
  endDate?: string | null;
  dateType?: string;
}

export interface SearchPagenateQuery extends PagenatedQuery, DatePeriodQuery {
  board?: string;
  category?: string;
  keyword?: string;
  type?: string;
  creditPointId?: string;
  profileStatus?: ProfileApprovalState | 'all';
  sort?: string;
  roles?: string[];
  commissionRateId?: string;
  partnerFilter?: 'all' | 'selling' | 'not-selling' | 'no-products';
  excellentPartner?: 'all' | 'yes' | 'no';
  emailAgreeFilter?: boolean;
  smsAgreeFilter?: boolean;
  membership?: string;
  hasMembership?: boolean;
  exportType?: string;
  /** When true, API applies parent-role and membership list filters (멤버십 가입 유저) */
  membershipUsers?: boolean;
  childBirthdayStart?: string;
  childBirthdayEnd?: string;
}

export interface CustomerRequest {
  _id: string;
  type: string;
  userId: string;
  user: User;
  userPhone: string;
  data: CustomerRequestData;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerRequestData {
  saleType: string;
  productId: string;
  productName: string;
  productUpdatedAt: string;
  memo: string;
  weekdays: string[];
}
